import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ModalComponent } from '../shared/modal/modal.component';

@Component({
  selector: 'bidsubmitted-dialog',
  standalone: true,
  imports: [CommonModule, RouterLink, ModalComponent],
  templateUrl: './bid-submitted-dialog.component.html',
  styleUrl: './bid-submitted-dialog.component.scss',
})
export class BidSubmittedDialogComponent {
  @Input() active: boolean = false;
  @Output() modalClosed = new EventEmitter<boolean>();

  @Input() documents: any = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }
  submit() {
    this.closeDialog();
  }
}
